import { render } from "./selectPoblacion.vue?vue&type=template&id=3faf6896"
import script from "./selectPoblacion.vue?vue&type=script&lang=ts"
export * from "./selectPoblacion.vue?vue&type=script&lang=ts"
script.render = render

export default script